import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Sidebar from './Sidebar';

const AppLayout = () => {
  const location = useLocation();

  // Page title har route ke liye
  const pageTitles = {
    '/Dashboard': 'Dashboard',
    '/Operation/Customer': 'Customer',
    '/loanmaster/Loan': 'Loans',
    '/loanmaster/Repayment': 'Repayment',
    '/loanmaster/MultipleLoans': 'Multiple Loans',
    '/account/PendingDisbursement': 'Pending Disbursement',
    '/account/Disbursement': 'Disbursement',
    '/TodayRepayment': 'Today Repayment',
    '/OverDue': 'Overdue',
    '/operation/Reject': 'Rejected',
    '/Operation/AllCustomer': 'All Customers',
    '/Operation/CreditCheck': 'Credit Check',
    '/Operation/BankVerification': 'Bank Verification',
    '/employee/AllEmployee': 'All Employees',
    '/Excel/ReportsDashboard': 'Reports Dashboard',
    '/Excel/Collection': 'Collection',
    '/Excel/Disbursed': 'Disbursed',
    '/Excel/MasterSheet': 'Master Sheet',
    '/Excel/LoanDeactivate': 'Loan Deactivate',
    '/Excel/EmiUpload': 'Upload Paid Sheet',
    '/fintech/Fintech': 'Fintech Partners',
    '/privllages/Permissions': 'Permissions',
    '/Profile': 'Profile',
    '/setting': 'Settings',
  };

  const title = pageTitles[location.pathname] || 'LMS Portal';

  return (
    <div className="app-shell">
      {/* Fixed top navbar */}
      <header className="app-header">
        <Navigation />
        <span className="app-page-title">{title}</span>
      </header>

      <div className="app-body">
        {/* Fixed sidebar */}
        <aside className="app-sidebar">
          <Sidebar />
        </aside>

        {/* Scrollable content area */}
        <main className="app-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
